import Reveal from '@/components/base/Reveal';

const summaryItems = [
  {
    index: '01',
    title: 'One Market',
    desc: 'The strategy is built around a single instrument, XAUUSD.',
  },
  {
    index: '02',
    title: 'Condition-Based',
    desc: 'Trades follow a defined condition framework, not every price move.',
  },
  {
    index: '03',
    title: 'Both Directions',
    desc: 'The recorded activity includes both long and short positions.',
  },
  {
    index: '04',
    title: 'Fully Recorded',
    desc: 'Every result, winning or losing, becomes part of the record.',
  },
];

function StrategyCta() {
  return (
    <section className="w-full border-t border-background-200 bg-background-50 px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <p className="text-[11px] font-data tracking-[0.24em] text-foreground-400 text-center mb-5">
            THE STRATEGY IN SHORT
          </p>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[25px] leading-[1.18] sm:text-[32px] lg:text-[36px] text-center max-w-[820px] mx-auto">
            One market, a defined framework, both directions, and a complete record.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-background-200 rounded-lg overflow-hidden border border-background-200">
          {summaryItems.map((item, idx) => (
            <Reveal key={item.index} delay={idx * 80}>
              <div className="h-full bg-background-50 px-6 py-8 md:py-9">
                <span className="font-data text-[11px] tracking-[0.2em] text-primary-600">
                  {item.index}
                </span>
                <h3 className="mt-4 font-heading text-[18px] md:text-[20px] font-bold tracking-tight text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-3 text-[13px] leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StrategyCta;